import angular from 'angular';

import rwSubordinatesTableModule from './components/rw-subordinates-table/rw-subordinates-table-module';
import rwSubordinatesDropdownModule from './components/rw-subordinates-dropdown/rw-subordinates-dropdown-module';


export default angular
  .module('rw-subordinates', [
    rwSubordinatesTableModule.name,
    rwSubordinatesDropdownModule.name,
  ]);



// WEBPACK FOOTER //
// ./src/modules/utils/rw-subordinates/rw-subordinates-module.js